module.exports = __webpack_public_path__ + "static/media/mayor_framed1.00b55372.png";